import { useScopedHostI18n } from '@gohighlevel/ghl-module-federation-plugin'
import { createI18n } from 'vue-i18n'
import da from './lang/da.json'
import de from './lang/de.json'
import enUS from './lang/en-US.json'
import es from './lang/es.json'
import fi from './lang/fi.json'
import frCA from './lang/fr-CA.json'
import frFR from './lang/fr-FR.json'
import it from './lang/it.json'
import nl from './lang/nl.json'
import no from './lang/no.json'
import ptBR from './lang/pt-BR.json'
import ptPT from './lang/pt-PT.json'
import sv from './lang/sv.json'

export const commonMessages = {
  'en-US': enUS,
  es,
  de,
  'fr-CA': frCA,
  'fr-FR': frFR,
  'pt-BR': ptBR,
  'pt-PT': ptPT,
  it,
  nl,
  sv,
  da,
  fi,
  no,
}

const i18n = createI18n({
  locale: localStorage.getItem('locale') || 'en-US',
  fallbackLocale: 'en-US',
  globalInjection: true,
  legacy: false,
  runtimeOnly: true,
  messages: commonMessages,
})

const loadedLocales = new Set<string>(['en-US'])

const localeFileMap: Record<string, () => Promise<{ default: any }>> = {
  da: () => import(/* webpackChunkName: "locale-da" */ './lang/da.json'),
  de: () => import(/* webpackChunkName: "locale-de" */ './lang/de.json'),
  es: () => import(/* webpackChunkName: "locale-es" */ './lang/es.json'),
  fi: () => import(/* webpackChunkName: "locale-fi" */ './lang/fi.json'),
  'fr-CA': () => import(/* webpackChunkName: "locale-fr-CA" */ './lang/fr-CA.json'),
  'fr-FR': () => import(/* webpackChunkName: "locale-fr-FR" */ './lang/fr-FR.json'),
  it: () => import(/* webpackChunkName: "locale-it" */ './lang/it.json'),
  nl: () => import(/* webpackChunkName: "locale-nl" */ './lang/nl.json'),
  no: () => import(/* webpackChunkName: "locale-no" */ './lang/no.json'),
  'pt-BR': () => import(/* webpackChunkName: "locale-pt-BR" */ './lang/pt-BR.json'),
  'pt-PT': () => import(/* webpackChunkName: "locale-pt-PT" */ './lang/pt-PT.json'),
  sv: () => import(/* webpackChunkName: "locale-sv" */ './lang/sv.json'),
}

export async function setLocale(locale: string): Promise<void> {
  const resolved = locale in localeFileMap || locale === 'en-US' ? locale : 'en-US'

  if (!loadedLocales.has(resolved)) {
    const loader = localeFileMap[resolved]
    if (loader) {
      try {
        const messages = await loader()
        i18n.global.setLocaleMessage(resolved, messages.default)
        loadedLocales.add(resolved)
      } catch {
        ;(i18n.global.locale as any).value = 'en-US'
        return
      }
    }
  }

  ;(i18n.global.locale as any).value = resolved
}

export default i18n

let scopeName = 'proposalCommon'

export function setScopeName(name: string) {
  scopeName = name
}

export function useVueI18n() {
  return (key: string, ...args: [any?, any?]) => {
    if (scopeName === '') {
      return i18n.global.t(key, ...args)
    }
    const { t } = useScopedHostI18n(scopeName)
    return t(key, ...args)
  }
}

export const i18nLocale = window.localStorage.getItem('locale') || 'en-US'
